import { Controller } from "@hotwired/stimulus"
import {
  CategoryScale,
  Chart,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  Tooltip
} from "chart.js"

Chart.register(CategoryScale, Legend, LinearScale, LineController, LineElement, PointElement, Tooltip)

export default class extends Controller {
  static values = {
    labels: Array,
    uniqueVisitors: Array,
    uniqueVisitorsLabel: String,
    views: Array,
    viewsLabel: String
  }

  connect() {
    this.renderChart()
    this.themeObserver = new MutationObserver(() => this.refreshColors())
    this.themeObserver.observe(document.documentElement, { attributes: true, attributeFilter: ["data-bs-theme"] })
  }

  disconnect() {
    this.themeObserver?.disconnect()
    this.chart?.destroy()
  }

  renderChart() {
    const colors = this.colors()

    this.chart = new Chart(this.element, {
      type: "line",
      data: {
        labels: this.labelsValue,
        datasets: [
          this.dataset(this.viewsLabelValue, this.viewsValue, colors.views),
          this.dataset(this.uniqueVisitorsLabelValue, this.uniqueVisitorsValue, colors.visitors)
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        interaction: { mode: "index", intersect: false },
        plugins: {
          legend: {
            labels: { color: colors.text, usePointStyle: true }
          }
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: { color: colors.text, maxTicksLimit: 7 }
          },
          y: {
            beginAtZero: true,
            grid: { color: colors.grid },
            ticks: { color: colors.text, precision: 0 }
          }
        }
      }
    })
  }

  dataset(label, data, color) {
    return {
      label,
      data,
      borderColor: color,
      backgroundColor: color,
      borderWidth: 3,
      pointRadius: 2,
      pointHoverRadius: 4,
      tension: 0.25
    }
  }

  refreshColors() {
    if (!this.chart) return

    const colors = this.colors()
    const [views, visitors] = this.chart.data.datasets

    views.borderColor = views.backgroundColor = colors.views
    visitors.borderColor = visitors.backgroundColor = colors.visitors
    this.chart.options.plugins.legend.labels.color = colors.text
    this.chart.options.scales.x.ticks.color = colors.text
    this.chart.options.scales.y.ticks.color = colors.text
    this.chart.options.scales.y.grid.color = colors.grid
    this.chart.update("none")
  }

  colors() {
    const styles = getComputedStyle(document.documentElement)

    return {
      views: styles.getPropertyValue("--bs-primary").trim(),
      visitors: styles.getPropertyValue("--bs-info").trim(),
      text: styles.getPropertyValue("--bs-secondary-color").trim(),
      grid: styles.getPropertyValue("--bs-border-color").trim()
    }
  }
}
